<template>
    <div id="index">
        <Banner v-if="imgs.length>0" :banner="imgs" />
<!--关于-->
        <div class="about-box">
            <div class="about">
                <div class="left">
                    <p><span class="title">关于颐思特</span></p>
                    <div class="txt">
                        <p v-html="about.detail"></p>
                    </div>
                    <div class="more" @click="$router.push('/about')">
                        <span>更多简介</span>
                        <img src="../assets/images/icon-right-1.png" alt="">
                    </div>
                </div>
                <div class="right">
                    <img v-if="about.img" :src="$imgBaseURL+about.img" alt="">
                </div>
            </div>
        </div>
<!--        产品展示-->
        <div class="product-box">
            <div class="product">
                <p><span class="title">产品中心</span></p>
                <ProductSwiper :productImg="productImg" />
                <div class="product-item">
                    <div class="item" v-for="item in productList" :key="item.name">
                        <img v-if="item.img" :src="$imgBaseURL+item.img" alt="">
                        <p class="name">{{item.name}}</p>
                        <p class="enName">{{item.enName}}</p>
                        <p class="desc">{{item.desc}}</p>
                        <button @click="$router.push('/product')">查看更多</button>
                    </div>
                </div>
            </div>
        </div>
<!--        新闻中心-->
        <div class="news-box">
            <div class="news">
                <p><span class="title">新闻中心</span></p>
                <div class="news-item">
                    <div class="item" v-for="item in news" :key="item.id">
                        <div class="left">
                            <img :src="$imgBaseURL+item.cover" alt="">
                        </div>
                        <div class="right" @click="$router.push('/news/detail?id='+item.id)">
                            <p class="t">{{item.title}}</p>
                            <p class="desc">{{item.extract}}</p>
                            <p class="time"><img src="../assets/images/icon-clock.png" alt=""><span>{{item.create_time | dateFormat('YYYY-MM-DD')}}</span></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="more" @click="$router.push('/news')">
                <button>了解更多<span>→</span></button>
            </div>
        </div>
<!--        技术服务-->
        <div class="service-box">
            <div class="service">
                <p><span class="title">技术服务</span></p>
                <div class="service-item">
                    <div class="item" v-for="(item,index) in service" :key="item.id">
                        <p class="t">{{item.title}}</p>
                        <p class="desc">{{item.subtitle}}</p>
                        <button @click="$router.push(`/salesService?active=${index}`)">查看详情</button>
                    </div>
                </div>
            </div>
        </div>
<!--        客户-->
        <div class="client-box">
            <div class="client">
                <p><span class="title">我们的客户</span></p>
                <div class="client-item">
                    <div class="item" v-for="item in client" :key="item.id"><img :src="$imgBaseURL+item.bg_url" alt=""></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from "../components/public/Banner";
    import ProductSwiper from "../components/index/ProductSwiper";
    export default {
        name: "Index",
        components:{Banner,ProductSwiper},
        data(){
            return{
                imgs:[],
                autoplay:false,
                productImg:[],
                productList:[
                    {name:'仪器设备',enName:'Equipment',desc:'专业提供蛋白质组、PTM修饰组、代谢组、转录组学等科技服务。'},
                    {name:'生物技术',enName:'Biotechnology',desc:'整合多学组，实现更好地将疾病风险、预后或治疗反应分类等个性化医疗的目的。'},
                    {name:'环保事业',enName:'Environmental protection',desc:'拜谱将服务新药和仿制新药的研发生产立为重大发展方向，推出严谨的生物药结构合征服务体系。'},
                ],
                about:{
                    detail:'',
                    img:''
                },
                service:[],
                client:[],
                news:[],
            }
        },
        methods:{
            //获取轮播图
            getNav(){
                this.$axios({
                    url:'/navigation/navigationbar',
                    method:'get'
                }).then(res=>{
                    if (res.data.code === 200){
                        this.imgs = res.data.msg.navigationBars[0].navigationImgs;
                        if (this.imgs.length>1){
                            this.autoplay = true;
                        }
                    }
                })
            },
            //关于
            getData(type){
                this.$axios({
                    url:'/moudle/moudlemaster',
                    method:'get',
                    params:{
                        moudleType:type
                    }
                }).then(res=>{
                    if (res.data.code === 200){
                        switch (type) {
                            case '1':
                                // this.about.detail = res.data.msg[0].moudleSlaves[0].subtitle;
                                this.about.img = res.data.msg[0].moudleSlaves[0].bg_url;
                                break;
                            case '2':
                                this.productImg = res.data.msg[0].moudleSlaves;
                                break;
                            case '3':
                                this.productList[0].name = res.data.msg[0].title;
                                this.productList[0].enName = res.data.msg[0].subtitle;
                                this.productList[0].desc = res.data.msg[0].moudleSlaves[0].subtitle;
                                this.productList[0].img = res.data.msg[0].logourl;
                                break;
                            case '4':
                                this.productList[1].name = res.data.msg[0].title;
                                this.productList[1].enName = res.data.msg[0].subtitle;
                                this.productList[1].desc = res.data.msg[0].moudleSlaves[0].subtitle;
                                this.productList[1].img = res.data.msg[0].logourl;
                                break;
                            case '5':
                                this.productList[2].name = res.data.msg[0].title;
                                this.productList[2].enName = res.data.msg[0].subtitle;
                                this.productList[2].desc = res.data.msg[0].moudleSlaves[0].subtitle;
                                this.productList[2].img = res.data.msg[0].logourl;
                                break;
                            case '7':
                                this.service = res.data.msg[0].moudleSlaves;
                                break;
                            case '8':
                                this.client = res.data.msg[0].moudleSlaves;
                                break;

                        }
                    }
                })
            },
            //获取关于
            getAbout(){
                this.$axios({
                    url:'/navigation/navigationbar',
                    method:'get'
                }).then(res=>{
                    if (res.data.code === 200){
                        this.about.detail = res.data.msg.navigationBars[1].navigationSubmenus[0].content;
                    }
                })
            },
            //获取新闻
            getNews(){
                this.$axios({
                    url:'/newscenter/getnews',
                    method:'get',
                    params:{
                        pageStart:1,
                        pageSize:4,
                        is_top:'',
                        type:1
                    }
                }).then(res=>{
                    if (res.data.code === 200){
                        this.news = res.data.msg.list;
                    }
                })
            }
        },
        created() {
            this.getNav();
            this.getData('1');
            this.getData('2');
            this.getData('3');
            this.getData('4');
            this.getData('5');
            this.getData('6');
            this.getData('7');
            this.getData('8');
            this.getNews();
            this.getAbout();
        }
    }
</script>

<style scoped lang="less">
#index{
    .title{
        color: #181818;
        font-size: 26px;
        font-weight: bold;
        &::after{
            content: '';
            vertical-align: text-bottom;
            color: #999999;
            font-size: 14px;
            margin-left: 10px;
        }
    }
    .about-box{
        background-color: #ffffff;
        padding: 40px 0;
        .about{
            width: 1180px;
            margin: 0 auto;
            display: flex;
            .left{
                flex: 1;
                margin-right: 100px;
                .title{
                    &::after{
                        content: '/ ABOUT US';
                    }
                }
                .txt{
                    margin-top: 30px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 8;
                    overflow: hidden;
                    p{
                        text-indent: 2em;
                        color: #181818;
                        font-size: 14px;
                        line-height: 24px;
                    }
                }
                .more{
                    margin-top: 47px;
                    span{
                        color: #307C48;
                        font-size: 16px;
                        font-weight: 500;
                        vertical-align: middle;
                    }
                    img{
                        width: 20px;
                        height: 20px;
                        vertical-align: middle;
                        margin-left: 10px;
                    }
                }
            }
            .right{
                img{
                    width: 328px;
                }
            }
        }
    }
    .product-box{
        background-color: #F4F4F4;
        padding: 40px 0;
        .product{
            width: 1180px;
            margin: 0 auto;
            .title{
                &::after{
                    content: '/ PRODUCT CENTER';
                }
            }
            .product-item{
                display: grid;
                grid-template-columns: repeat(3,1fr);
                grid-gap: 0 20px;
                margin-top: 30px;
                .item{
                    background-color: #ffffff;
                    border-radius: 10px;
                    border: 1px solid #D8D8D8;
                    padding: 20px;
                    overflow: hidden;
                    text-align: center;
                    img{
                        width: 100%;
                    }
                    .name{
                        color: #333333;
                        font-size: 18px;
                        margin-top: 20px;
                        font-weight: bold;
                    }
                    .enName{
                        color: #666666;
                        font-size: 16px;
                        margin-top: 10px;
                    }
                    .desc{
                        color: #666666;
                        font-size: 14px;
                        margin-top: 20px;
                        position: relative;
                        &::before{
                            content: '';
                            display: block;
                            width: 60px;
                            height: 1px;
                            background-color: #979797;
                            margin: 0 auto;
                            margin-bottom: 30px;
                        }
                    }
                    button{
                        width: 108px;
                        height: 36px;
                        line-height: 34px;
                        font-size: 14px;
                        border: 1px solid #307C48;
                        color: #307C48;
                        border-radius: 2px;
                        background-color: #ffffff;
                        cursor: pointer;
                        margin-top: 33px;
                        margin-bottom: 10px;
                        padding: 0;
                        &:hover{
                            color: #ffffff;
                            background-color: #307C48;
                            transition: 0.3s linear;
                        }
                    }
                    &:hover{
                        .desc{
                            &::before{
                                width: 200px;
                                background-color: #307C48;
                                transition: 0.3s linear;
                            }
                        }
                    }
                }
            }
        }
    }
    .news-box{
        background-color: #ffffff;
        padding: 40px 0;
        .news{
            width: 1180px;
            margin: 0 auto;
            .title{
                &::after{
                    content: '/ NEWS CENTER';
                }
            }
            .news-item{
                margin-top: 30px;
                display: grid;
                grid-template-columns: repeat(2,1fr);
                grid-gap: 20px;
                .item{
                    display: flex;
                    padding: 20px;
                    border-radius: 10px;
                    border: 1px solid #D8D8D8;
                    .left{
                        img{
                            width: 220px;
                            height: 130px;
                        }
                        margin-right: 20px;
                    }
                    .right{
                        flex: 1;
                        .t{
                            color: #181818;
                            font-size: 16px;
                            font-weight: bold;
                            line-height: 32px;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            white-space: nowrap;
                        }
                        .desc{
                            margin-top: 6px;
                            color: #3D3D3D;
                            font-size: 14px;
                            line-height: 24px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                        }
                        .time{
                            margin-top: 24px;
                            img{
                                width: 20px;
                                height: 20px;
                                vertical-align: middle;
                                margin-right: 8px;
                            }
                            span{
                                color: #999999;
                                font-size: 14px;
                                vertical-align: middle;
                            }
                        }
                    }
                }
            }
        }
        .more{
            text-align: center;
            margin-top: 40px;
            button{
                width: 152px;
                height: 36px;
                padding: 0;
                line-height: 34px;
                border: 1px solid #AABDB0;
                border-radius: 18px;
                color: #307C48;
                font-size: 14px;
                cursor: pointer;
                background-color: #ffffff;
                &:focus{
                    outline: none;
                }
                span{
                    margin-left: 22px;
                }
            }
        }
    }
    .service-box{
        background-color: #F4F4F4;
        padding: 40px 0;
        .service{
            width: 1180px;
            margin: 0 auto;
            .title{
                &::after{
                    content: '/ TECHNICAL SERVICES';
                }
            }
            .service-item{
                margin-top: 30px;
                display: grid;
                grid-template-columns: repeat(3,1fr);
                grid-gap: 0 20px;
                .item{
                    padding: 20px;
                    border-radius: 10px;
                    border: 1px solid #D8D8D8;
                    background-color: #ffffff;
                    .t{
                        color: #181818;
                        font-size: 22px;
                        font-weight: bold;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                    .desc{
                        color: #3D3D3D;
                        font-size: 14px;
                        margin-top: 16px;
                        line-height: 24px;
                        height: 48px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }
                    button{
                        color: #307C48;
                        border: 1px solid #307C48;
                        border-radius: 2px;
                        font-size: 12px;
                        padding: 3px 5px;
                        margin-top: 16px;
                        cursor: pointer;
                        background-color: #ffffff;
                    }
                }
            }
        }
    }
    .client-box{
        background-color: #ffffff;
        .client{
            width: 1180px;
            padding: 40px 0;
            margin: 0 auto;
            .title{
                &::after{
                    content: '/ OUR CLIENT';
                }
            }
            .client-item{
                margin-top: 30px;
                display: grid;
                grid-template-columns: repeat(6,1fr);
                grid-gap: 20px;
                .item{
                    border: 1px solid #D8D8D8;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 76px;
                    overflow: hidden;
                    img{
                        width: 100%;
                    }
                }
            }
        }
    }
}
</style>
